// Actions
export const DRAG_START = 'DRAG_START';
export const DRAG_END = 'DRAG_END';
export const REPLACE_MODE_START = 'REPLACE_MODE_START';
export const REPLACE_MODE_END = 'REPLACE_MODE_END';

export const DRAG_PREVIEW_ID = 'previewElement';
export const LINE_EDGE_DRAG_PREVIEW_ID = '_LINE_PREVIEW';
